import { IntegrationEmailThread } from '../../../models/Email'
import { useMemo } from 'react'
import { selectEmailContacts } from '../../../store/emailHub/emailUsers'
import { useAppSelector } from '../../../store/hooks'
import { selectEmailMetadata } from '../../../store/emailHub/emailMetadata'

export const useLastContactEmailFromThread = (thread: IntegrationEmailThread) => {
  const emailMetadata = useAppSelector(selectEmailMetadata)
  const contacts = useAppSelector(selectEmailContacts)

  const lastEmailByContact = useMemo(
    () =>
      thread.emails
        .slice()
        .reverse()
        .find((email) => contacts.some((contact) => contact.email?.toLowerCase() === email.sender.email.toLowerCase())),
    [contacts, thread],
  )

  const lastEmailByContactMetadata = useMemo(() => {
    if (!lastEmailByContact) {
      return null
    }
    return emailMetadata.find((metadata) => metadata.externalId === lastEmailByContact.externalId) ?? null
  }, [emailMetadata, lastEmailByContact])

  return { lastEmailByContact, lastEmailByContactMetadata }
}
